import React, { useCallback } from "react"
import { useAccount } from "wagmi"

import { RootState, selectTokenDecimals, useDappSelector } from "#/redux-state"
import { MezoNativeBTC } from "#/shared/constants/artifacts"
import {
  useERC20TokenBalance,
  useModalCustomOptions,
  useStake,
} from "#/shared/hooks"
import { bigIntToFloat } from "#/shared/utils"
import { ComponentStepProps, useStepperModalContext } from "#/ui/Modal"

import { StakingForm } from "../../components"

export default function IncreaseAmountStep({
  onClickContinue,
}: ComponentStepProps) {
  const { address } = useAccount()
  const { data: balance } = useERC20TokenBalance(MezoNativeBTC.address, address)

  const tokenDecimals = useDappSelector((state: RootState) =>
    selectTokenDecimals(state, "mBTC"),
  )

  const { values: initialValues, setValues } = useStepperModalContext<{
    amount: string
  }>()

  const { stakeId } = useModalCustomOptions<{
    stakeId: string
  }>()

  const selectedStake = useStake(stakeId)

  const handelSubmitForm = useCallback(
    (values: { amount: string }) => {
      setValues(values)
      onClickContinue()
    },
    [onClickContinue, setValues],
  )

  if (!selectedStake) return null

  return (
    <StakingForm
      initialValues={{
        ...initialValues,
        lockDuration: selectedStake.lockDuration,
      }}
      onSubmitForm={handelSubmitForm}
      token="BTC"
      tokenDecimals={tokenDecimals}
      balance={bigIntToFloat(balance ?? 0n)}
    />
  )
}
